import { ServiceLanguage, Tenant } from "albertine-shared-web";
import { z } from "zod";

export const feedbackSearchSchema = z.object({
    tenant: Tenant,
    locale: ServiceLanguage,
    requestId: z.string().min(1),
    bookingId: z.string().min(1).optional(),
});

export type FeedbackSearch = z.infer<typeof feedbackSearchSchema>;
